import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  templateUrl: './admin-not-found.component.html',
  styleUrls: ['./admin-not-found.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AdminNotFoundComponent implements OnInit {

  constructor(private route:ActivatedRoute, private router:Router) { }

  ngOnInit(): void {
  }

}
